module.exports = __webpack_public_path__ + "static/img/hospitality-small.3df73ae.jpg";